<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-row>
                    <el-form-item label="采购组织" label-width="80px">
                        <el-select v-model="dataForm.purOrg" clearable filterable placeholder="请选择组织">
                            <el-option v-for="item in purchaseOrgList" :key="item.purchaseOrgCode" :label="item.purchaseOrgCode+'_'+item.purchaseOrgName" :value="item.purchaseOrgCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="供应商代码" prop="venderCode">
                        <el-input clearable size="mini" v-model="dataForm.venderCode" :disabled = "userInfo.typeId == USER_TYPE.SUPPLIER" style="width: 150px " placeholder="供应商代码" @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="venderName">
                        <el-input clearable size="mini" v-model="dataForm.venderName" :disabled = "userInfo.typeId == USER_TYPE.SUPPLIER" style="width: 150px " placeholder="供应商名称" @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="年度分类" label-width="80px">
                        <el-cascader v-model="yearTypes" :options="YEAR_TYPE_VALUE" :props="{ multiple: true, checkStrictly: true }" collapse-tags clearable></el-cascader>
                    </el-form-item>
                   <el-form-item label="评价年度" label-width="80px">
                       <el-select v-model="dataForm.year1" clearable placeholder="请选择">
                          <el-option v-for="item in year1List" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                       </el-select>
                       至
                       <el-select v-model="dataForm.year2" clearable placeholder="请选择">
                          <el-option v-for="item in year2List" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                       </el-select>
                   </el-form-item>
                    <el-form-item label="供应商等级" label-width="100px">
                        <el-cascader v-model="classTypes" :options="CLASS_TYPE_VALUE" :props="{ multiple: true, checkStrictly: true }" collapse-tags clearable></el-cascader>
                    </el-form-item>
                    <el-form-item class="fr">
                        <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:0px">查询
                        </el-button>
                        <el-button size="mini" @click="exportData()" icon="el-icon-plus">导出</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="tableHeight" @selection-change="selectionChangeHandle"
                  :header-cell-style="{background:'#f5f5f5'}" border>
            <el-table-column align="center" v-model="something" type="selection" width="50">
            </el-table-column>
            <el-table-column header-align="center" label="序号" align="center" width="50">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
            <el-table-column prop="purOrg" header-align="center" align="center" label="采购组织代码" min-width="80">
                <template slot-scope="scope">
                    {{ scope.row.purOrg }}
                </template>
            </el-table-column>
            <el-table-column prop="desc" header-align="center" align="left" label="绩效评价名称" min-width="180">
                <template slot-scope="scope">
                     {{ scope.row.evaName }}
                </template>
            </el-table-column>
            <el-table-column prop="venderCode" header-align="center" align="center" label="供应商代码" min-width="80">
                <template slot-scope="scope">
                    {{ scope.row.venderCode }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="center" label="供应商名称" min-width="120">
                <template slot-scope="scope">
                    <el-button type="text" @click="openPenalty(scope.row)">{{ scope.row.venderName }}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="venderAbbreviation" header-align="center" align="center" label="供应商简称" min-width="60">
                <template slot-scope="scope">
                    {{ scope.row.venderAbbreviation }}
                </template>
            </el-table-column>
            <el-table-column prop="product" header-align="center" align="center" label="产品" min-width="100">
            </el-table-column>
            <el-table-column prop="partType" header-align="center" align="center" label="零部件类别" min-width="100">
            </el-table-column>
            <el-table-column prop="brand" header-align="center" align="center" label="品牌" min-width="90">
            </el-table-column>
            <el-table-column prop="factory" header-align="center" align="center" label="工厂" min-width="90">
            </el-table-column>
            <el-table-column prop="total" header-align="center" align="center" label="供应商得分" min-width="80" >
                <template slot-scope="scope">
                    {{ scope.row.total }}
                </template>
            </el-table-column>
            <el-table-column prop="classType" header-align="center" align="center" label="供应商等级" min-width="60" >
                <template slot-scope="scope">
                    <el-tag size="mini" effect="dark" :style="classTagStyle(scope.row.classType)">
                        {{ scope.row.classType }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column  align="center"label="质量">
                <el-table-column prop="sckkx" align="center" :label="'市场可靠性质量\n(6分)'" width="70">
                </el-table-column>
                <el-table-column prop="rclbj" :label="'零部件零公里质量\n(8分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="scgc" :label="'生产过程质量\n(10分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="lbjzl" :label="'零部件质量改进\n(6分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="skfy" :label="'受控发运\n(4分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="zlbh" :label="'质量问题反馈\n(6分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="成本">
                <el-table-column prop="jcbyj" align="center" :label="'降低业绩\n(10分)'" width="70">
                </el-table-column>
                <el-table-column prop="pjjgsp" :label="'平均价格水平\n(5分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="swphd" align="center" :label="'商务配合度\n(5分)'" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="交付">
                <el-table-column prop="lbjgh" :label="'零部件供货\n(10分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="ghfw" :label="'供货服务\n(10分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="服务">
                <el-table-column prop="xcfwzc" align="center" :label="'现场服务支持\n(3分)'" width="70">
                </el-table-column>
                <el-table-column prop="shpjjf" :label="'售后配件交付\n(7分)'" align="center" width="70">
                </el-table-column>
<!--                <el-table-column prop="shfwxysd" :label="'售后服务响应速度\n(3分)'" align="center" width="70">-->
<!--                </el-table-column>-->
            </el-table-column>
            <el-table-column  align="center"label="开发">
                <el-table-column prop="xcpkfph" align="center" :label="'开发进度\n(5分)'" width="70">
                </el-table-column>
                <el-table-column prop="xpkfyj" :label="'开发质量\n(5分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="得分汇总">
                <el-table-column prop="penaltyQuality" align="center" label="质量分数" width="70">
                    <template slot-scope="scope">
                        <span style="color:#e6a23c">{{ scope.row.penaltyQuality }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="penaltyCost" align="center" label="成本分数" width="70">
                    <template slot-scope="scope">
                        <span style="color:#e6a23c">{{ scope.row.penaltyCost }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="penaltyDelivery" align="center" label="交付分数" width="90">
                    <template slot-scope="scope">
                        <span style="color:#67c23a">{{ scope.row.penaltyDelivery }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="penaltyService" align="center" label="服务分数" width="70">
                    <template slot-scope="scope">
                        <span style="color:#67c23a">{{ scope.row.penaltyService }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="penaltyDev" align="center" label="开发分数" width="70">
                    <template slot-scope="scope">
                        <span style="color:#67c23a">{{ scope.row.penaltyDev }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="操作" width="110">
                <template slot-scope="scope">
                    <el-button type="text" @click="openPenalty(scope.row)">查看扣分详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>
        <penalty-detail ref="penaltyDetail" v-if="penaltyVisible" :row="penaltyRow" @close="penaltyVisible=false"></penalty-detail>
    </div>
</template>
<script>
    import {getSupplierEvaList,importSupplierEva,getSupplierByLoginName,exportSupplierEvaData,getSupplierPenaltyDetail} from '@/controller/supplier'
import PenaltyDetail from '../../supplier/supplierEvaManage/penalty-detail.vue'
import {
    getPurchaseOrgList
} from '@/controller/systemData'
import {getUserInfoByToken} from '@/controller/sys'
import {
    YEAR_TYPE_VALUE,
    CLASS_TYPE_VALUE,
    USER_TYPE
} from "@/utils/const";
    export default {
        components: { PenaltyDetail },
        data() {
            return {
                submitLoading:false,
                dialogVisible: false,
                penaltyVisible: false,
                penaltyRow: {},
                dataForm: {
                    key: '',
                    year1: new Date().getFullYear(),
                    yearTypes: [],
                    months: [],
                    classTypes: [],
                    venderName: '',
                    venderCode: '',
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                something: '',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
                    }
                },
                options1: [{
                        value: '0',
                        label: '新建'
                    }, {
                        value: '1',
                        label: '已发布'
                    }
                ],
                purchaseOrgList: [],
                yearTypes: [],
                classTypes: [],
                YEAR_TYPE_VALUE: YEAR_TYPE_VALUE,
                year1List: [],
                year2List: [],
                CLASS_TYPE_VALUE: CLASS_TYPE_VALUE,
                userInfo: '',
                USER_TYPE: USER_TYPE,
            }
        },
        computed: {
            tableHeight: {
                get() {
                    return this.$store.state.common.documentClientHeight - 260
                }
            }
        },
        activated() {
            this.getYearList()
            // 采购组织
            this.getPurchaseOrgList()
            // 获取当前登录人员信息
            getUserInfoByToken({}).then(data => {
                if (data && data.code === '00') {
                    this.userInfo = data.body.user
                    //如果是供应商用户，则搜索条件设置供应商
                    if(this.userInfo.typeId === this.USER_TYPE.SUPPLIER) {
                        getSupplierByLoginName({
                            loginName : this.userInfo.loginName
                        }).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.venderCode = data.body.venderCode
                                this.dataForm.venderName = data.body.venderName
                                this.getDataList()
                            } else {
                                this.dataList = []
                            }
                        })
                    }
                }
            })
        },
        methods: {

            openPenalty(row) {
                this.penaltyRow = row
                this.penaltyVisible = true
                this.$nextTick(() => {
                    this.$refs.penaltyDetail && this.$refs.penaltyDetail.init(row)
                })
            },
            // 供应商等级标签样式：A蓝/B绿/C橙(黑字)/D红
            classTagStyle(v) {
                const m = { A: '#409eff', B: '#67c23a', C: '#e6a23c', D: '#f56c6c' }
                const c = m[v]
                if (!c) return ''
                const color = v === 'C' ? '#000' : '#fff'
                return `background:${c};border-color:${c};color:${color}`
            },
            dateFormat: function (row, column) {
              var date = row[column.property]
              if (!date) {
                  return ''
              }
              return moment(date).format("YYYY-MM-DD HH:mm:ss")
            },
        
            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                var pYear1 = this.dataForm.year1
                var pYear2 = this.dataForm.year2
                if(pYear1 > pYear2) {
                    this.$message.warning("评价年度1不能大于评价年度2！")
                    return
                }
                this.dataListLoading = true
                this.dataForm.yearTypes = []
                this.dataForm.months = []
                this.yearTypes.forEach(yearType => {
                    // '0'/'1'/'2' 为年度分类(EVA_TYPE)，'01'-'12' 为月度(走 YEAR_MONTH 末两位)
                    var v = yearType[0]
                    if (v === '0' || v === '1' || v === '2') {
                        this.dataForm.yearTypes.push(v)
                    } else {
                        this.dataForm.months.push(v)
                    }
                })
                this.dataForm.classTypes = []
                this.classTypes.forEach(classType => {
                    this.dataForm.classTypes.push(classType[0])
                })
                getSupplierEvaList({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'purOrg': this.dataForm.purOrg,
                    'venderCode': this.dataForm.venderCode,
                    'venderName': this.dataForm.venderName,
                    'evaTypes': this.dataForm.yearTypes,
                    'months': this.dataForm.months,
                    'evaYear1': this.dataForm.year1,
                    'evaYear2': this.dataForm.year2,
                    'classTypes': this.dataForm.classTypes
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //多选
            selectionChangeHandle(val) {
                console.log(val)
                this.dataListSelections = val
            },
            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },

            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },
            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },

            // 导出供应商绩效
            exportData () {
                const params = {
                    'purOrg': this.dataForm.purOrg,
                    'venderCode': this.dataForm.venderCode,
                    'venderName': this.dataForm.venderName,
                    'evaTypes': this.dataForm.yearTypes,
                    'months': this.dataForm.months,
                    'evaYear1': this.dataForm.year1,
                    'evaYear2': this.dataForm.year2,
                    'classTypes': this.dataForm.classTypes
                }
                exportSupplierEvaData(params).then((data) => {
                    if(data && data.code == '00') {
                        this.readAsBinaryString(data.body)
                    } else {
                        this.$message.error(data.msg)
                    }
                }).catch((e) => {
                    console.log(e)
                })
            },
            readAsBinaryString(data) {
                // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
                // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
                const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
                const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
                let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
                dom.style.display = 'none';
                dom.href = url;
                dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
                document.body.appendChild(dom);
                dom.click();
            },
            str2Blob(str, mime) {
                var arr = str.split(',')
                var bstr = atob(arr[0]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime
                });
            },
            // 下拉输入采购组织
            getPurchaseOrgList() {
                getPurchaseOrgList({
                    purchaseOrgCode: "",
                    purchaseOrgName: "",
                }).then(data => {
                    if (data && data.code === '00') {
                        this.purchaseOrgList = data.body;
                    }
                });
            },
           //获得评价年度
           getYearList() {
               var date = new Date();
               var year = date.getFullYear()
               for(var i = 2020; i <= year; i++) {
                   var obj = {"value" : i, "label" : i}
                   this.year1List.push(obj);
                   this.year2List.push(obj);
               }
           },
        }
    }
</script>

<style lang="scss">
    .fr { float: right; }

    .button-danger { color: #F56C6C; }
</style>